import { render, staticRenderFns } from "./StepsInfo.vue?vue&type=template&id=19ba86c2&scoped=true&"
import script from "./StepsInfo.vue?vue&type=script&lang=js&"
export * from "./StepsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ba86c2",
  null
  
)

export default component.exports